import { type ComponentType, type ReactNode } from 'react';
import GooglePassUpdateContent from './content/GooglePassUpdateContent';
import ApplePassUpdateContent from './content/ApplePassUpdateContent';

export interface AnnouncementContentProps {
  dots?: ReactNode;
}

export interface AnnouncementConfig {
  id: string;
  expiresAt: string;
  Content: ComponentType<AnnouncementContentProps>;
  ctaLabel: string;
  standaloneCtaLabel?: string;
  ctaRoute?: string;
  standaloneCtaRoute?: string;
  featureFlag?: string;
}

export const ANNOUNCEMENTS: AnnouncementConfig[] = [
  {
    id: 'google-pass-v2-2026',
    expiresAt: '2026-11-01',
    Content: GooglePassUpdateContent,
    ctaLabel: 'Explore templates',
    standaloneCtaLabel: 'Explore enhanced pass presets',
    ctaRoute: '/pass-templates',
    standaloneCtaRoute: '/pass-templates?createTemplate=1',
  },
  {
    id: 'apple-enhanced-pass-2026',
    expiresAt: '2026-11-01',
    Content: ApplePassUpdateContent,
    ctaLabel: 'Explore presets',
    standaloneCtaLabel: 'Explore enhanced pass presets',
    ctaRoute: '/pass-templates?createTemplate=1',
    standaloneCtaRoute: '/pass-templates?createTemplate=1',
    featureFlag: 'appleEnhancedDesignEnabled',
  },
];
